import { FC, useState } from 'react';
import { Box, IconButton, Tooltip } from '@wix/design-system';
import { ChevronLeftSmall, ChevronRightSmall } from '@wix/wix-ui-icons-common';
import {
  ACTIONS,
  useTemplatesContext,
} from '@components/Contexts/TemplatesContext';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { useTemplatesBi } from '@components/Hooks/useTemplatesBi';
import s from './FilterToggle.module.scss';

const transitionTimeInMS = 0.8 * 1000;

const FilterToggle: FC = () => {
  const { t } = useTranslation();
  const {
    state: { filterOpen },
    dispatch,
  } = useTemplatesContext();
  const [isTooltipDisabled, setIsTooltipDisabled] = useState(false);
  const { logBiClick } = useTemplatesBi({ is_mobile: false });

  function listSwitch() {
    logBiClick({
      click_type: filterOpen ? 'Hide filters' : 'Show filters',
    });
    setIsTooltipDisabled(true);
    dispatch({ type: ACTIONS.TOGGLE_FILTER });
    setTimeout(() => {
      setIsTooltipDisabled(false);
    }, transitionTimeInMS);
  }

  const tooltipText = filterOpen
    ? 'marketplace.templates-page.filter-toggle.close'
    : 'marketplace.templates-page.filter-toggle.open';

  return (
    <Box height="0px" className={s.toggleContainer}>
      <div className={s.toggle}>
        <Tooltip
          content={t(tooltipText)}
          placement="right"
          disabled={isTooltipDisabled}
        >
          <IconButton
            ariaLabel={t(tooltipText)}
            skin="inverted"
            size="small"
            onClick={listSwitch}
            aria-label={t(tooltipText)}
          >
            {filterOpen ? <ChevronLeftSmall /> : <ChevronRightSmall />}
          </IconButton>
        </Tooltip>
      </div>
    </Box>
  );
};

export default FilterToggle;
